import { Component, ViewEncapsulation } from '@angular/core';
import { DhabiLoaderServiceService } from 'src/app/services/loader/dhabi-loader-service.service';

@Component({
  selector: 'app-dhabi-loader',
  templateUrl: './dhabi-loader.component.html',
  styleUrls: ['./dhabi-loader.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class DhabiLoaderComponent {
  constructor(public loader: DhabiLoaderServiceService){}
}
